module.exports = __webpack_public_path__ + "static/media/Drone-Photo-2-lazy.cebc9291.jpg";